import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EmailPreview } from '@/components/email/EmailPreview';

// Display-only preview of the system-admin invite email. The email body is the BE's single owner render
// (GET /admin/email-previews/admin-invite, from messages_ko) — the FE no longer builds its own template
// (clients display the server render, never re-author it). The dev toolbar toggles the resend banner (re-fetches with resend=true).
// `?resend=true` query starts the page in resend mode.

export function AdminInviteEmailPage() {
  const { t } = useTranslation('admin');
  const [searchParams] = useSearchParams();
  const [isResend, setIsResend] = useState(searchParams.get('resend') === 'true');

  return (
    <div className="admin-email-preview-page">
      <div className="admin-email-preview-page__back">
        <Link to="/admin-management">
          {t('adminManagement.inviteEmail.backToList')}
        </Link>
      </div>

      <div className="email-preview-toolbar">
        <span className="email-preview-toolbar__label">
          {t('adminManagement.inviteEmail.toolbarLabel')}
        </span>
        <div className="email-preview-toolbar__seg">
          <button
            type="button"
            className={isResend ? '' : 'is-active'}
            onClick={() => setIsResend(false)}
          >
            {t('adminManagement.inviteEmail.toolbarNormal')}
          </button>
          <button
            type="button"
            className={isResend ? 'is-active' : ''}
            onClick={() => setIsResend(true)}
          >
            {t('adminManagement.inviteEmail.toolbarResend')}
          </button>
        </div>
      </div>

      <EmailPreview kind="admin-invite" resend={isResend} />
    </div>
  );
}
